import { render, staticRenderFns } from "./editWhitelabel.vue?vue&type=template&id=4c8ed06a&"
import script from "./editWhitelabel.vue?vue&type=script&lang=js&"
export * from "./editWhitelabel.vue?vue&type=script&lang=js&"
import style0 from "./editWhitelabel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports